export const experiences = [
    {
        company: "Kreatik Digital",
        position: "Web Developer",
        info: [`Web developing with WordPress, PHP, JavaScript, jQuery, WooCommerce, Elementor and Divi.`, 
        `- Creating everything from simple websites to E-commerces with thousands of products.`, 
        `- Websites performance and user experience improvements.`],
        chronology: "Feb 2023 - Present",
        currently: true
    },
    {
        company: "Nath",
        position: "Full Stack Developer",
        info: ["Development and deployment of an application for recording work hours, shifts and tasks, with Laravel and JavaScript. Application entirely developed by me and currently being used in the company."],
        chronology: "Jan 2022 - May 2022"
    },
    {
        company: "Hospital Comarcal d'Amposta",
        position: "IT Helpdesk",
        info: ["Computer maintenance, inventory, assembly and repair of computers, troubleshooting from the ticketing system and user manuals. Active Directory and DNS management."],
        chronology: "Oct 2020 - Jun 2021"
    }
]
